import State from './state';

const resetState = state => {
  Object.assign(state, State);
};

const setError = (state, errorMessage) => {
  state.error = errorMessage;
};

const setLoading = (state, isLoading) => {
  state.loading = isLoading;
};

const setCompanyFilter = (state, companyId) => {
  if (companyId !== state.filters.company) {
    state.filters.company = companyId;
  }
};

const setDateFilter = (state, date) => {
  if (date !== state.filters.date) {
    state.filters.date = date;
  }
};

const setInspectorFilter = (state, inspectorId) => {
  if (inspectorId !== state.filters.inspector) {
    state.filters.inspector = inspectorId;
  }
};

const setMonthFilter = (state, month) => {
  if (month !== state.filters.month) {
    state.filters.month = month;
  }
};

const setTimeFilter = (state, time) => {
  if (time !== state.filters.time) {
    state.filters.time = time;
  }
};

const setRecords = (state, availabilities) => {
  state.records = availabilities || [];
};

const setInspectors = (state, inspectors) => {
  state.inspectors = inspectors || [];
};

export default {
  resetState,
  setError,
  setLoading,
  setCompanyFilter,
  setDateFilter,
  setInspectors,
  setInspectorFilter,
  setMonthFilter,
  setTimeFilter,
  setRecords,
};
